(function () {
  function mertraArrowClick(btn, dir) {
    if (window.event) {
      window.event.preventDefault();
      window.event.stopPropagation();
    }

    // ── card-gallery (slideshow-slide) path ──────────────────────────
    var gallery = btn.closest('.card-gallery');
    if (gallery) {
      var slides = Array.from(gallery.querySelectorAll('slideshow-slide'));
      if (slides.length < 2) return;

      var cardEl = gallery.closest('li, product-card, .product-grid__item');
      var dots = cardEl ? Array.from(cardEl.querySelectorAll('.mertra-dot')) : [];

      var currentIdx = 0;
      slides.forEach(function (slide, i) {
        if (slide.getAttribute('aria-hidden') !== 'true') currentIdx = i;
      });

      var nextIdx = ((currentIdx + dir) + slides.length) % slides.length;

      slides.forEach(function (slide, i) {
        slide.setAttribute('aria-hidden', i === nextIdx ? 'false' : 'true');
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === nextIdx);
      });
      return;
    }

    // ── resource-card (plain img) path ───────────────────────────────
    var mediaBox = btn.closest('.resource-card__media');
    if (!mediaBox) return;

    var imgs = Array.from(mediaBox.querySelectorAll('img'));
    if (imgs.length < 2) return;

    var cardEl2 = mediaBox.closest('.resource-card');
    var dots2 = cardEl2 ? Array.from(cardEl2.querySelectorAll('.mertra-dot')) : [];

    var currentIdx2 = 0;
    imgs.forEach(function (img, i) {
      if (img.style.display !== 'none' && !img.classList.contains('mertra-rc-hidden')) {
        currentIdx2 = i;
      }
    });

    var nextIdx2 = ((currentIdx2 + dir) + imgs.length) % imgs.length;

    imgs.forEach(function (img, i) {
      if (i === nextIdx2) {
        img.classList.remove('mertra-rc-hidden');
      } else {
        img.classList.add('mertra-rc-hidden');
      }
    });
    dots2.forEach(function (dot, i) {
      dot.classList.toggle('is-active', i === nextIdx2);
    });
  }

  window.mertraArrowClick = mertraArrowClick;
})();
